import {createRouter, createWebHistory, RouterView} from 'vue-router'
import translations from "@/core/helpers/translations.js";
import HomePage from "@/pages/home-page.vue";
import RegisterPage from "@/pages/register-page.vue";
import LoginPage from "@/pages/login-page.vue";
import DefaultLayout from "@/layouts/default-layout.vue";
import AuthLayout from "@/layouts/auth-layout.vue";
import ResetPasswordPage from "@/pages/reset-password-page.vue";
import NewPasswordPage from "@/pages/new-password-page.vue";
import StorePage from "@/pages/store-page.vue";
import ProductPage from "@/pages/product-page.vue";
import {checkAuth} from "@/core/guards/notAuthGuard.js";
import ProfilePage from "@/pages/profile-page.vue";
import ProfileInfo from "@/components/profile/profile-info.vue";
import ProfileCart from "@/components/profile/profile-cart.vue";
import ProfileWishlist from "@/components/profile/profile-wishlist.vue";
import ProfileBalance from "@/components/profile/profile-balance.vue";
import ProfileOrders from "@/components/profile/profile-orders.vue";
import PolicyPage from "@/pages/policy-page.vue";
import TermsPage from "@/pages/terms-page.vue";
import CheckoutPage from "@/pages/checkout-page.vue";
import FaqPage from "@/pages/faq-page.vue";

const routes = [
  {
    path: '/:locale?',
    component: RouterView,
    beforeEnter: translations.routeMiddleware,
    children: [
      {
        path: '',
        component: DefaultLayout,
        children: [
          {
            path: '',
            name: 'home',
            component: HomePage,
            meta: {
              title: "Home"
            }
          },
          {
            path: 'activate-user',
            name: 'activate-user',
            component: HomePage,
            meta: {
              title: 'Home'
            }
          },
          {
            path: 'store',
            name: 'store',
            component: StorePage,
            meta: {
              title: "Store"
            }
          },
          {
            path: 'product/:productSlug',
            name: 'product',
            component: ProductPage,
            meta: {
              title: 'Product'
            }
          },
          {
            path: 'privacy-policy',
            name: 'policy',
            component: PolicyPage,
            meta: {
              title: 'Privacy Policy'
            }
          },
          {
            path: 'terms-of-use',
            name: 'terms',
            component: TermsPage,
            meta: {
              title: 'Terms Of User'
            }
          },
          {
            path: 'faq',
            name: 'faq',
            component: FaqPage,
            meta: {
              title: 'FAQ'
            }
          },
          {
            path: 'checkout/payment',
            name: 'checkout',
            component: CheckoutPage,
            meta: {
              title: 'Checkout'
            }
          },
          {
            path: 'profile',
            name: 'profile',
            component: ProfilePage,
            beforeEnter: checkAuth,
            meta: {
              title: "Profile"
            },
            children: [
              {
                path: 'info',
                name: 'profile-info',
                component: ProfileInfo
              },
              {
                path: 'cart',
                name: 'profile-cart',
                component: ProfileCart
              },
              {
                path: 'wishlist',
                name: 'profile-wishlist',
                component: ProfileWishlist
              },
              {
                path: 'balance',
                name: 'profile-balance',
                component: ProfileBalance
              },
              {
                path: 'orders',
                name: 'profile-orders',
                component: ProfileOrders
              },
            ]
          }
        ]
      },
      {
        path: '',
        component: AuthLayout,
        children: [
          {
            path: 'sign-up',
            name: 'auth-register',
            component: RegisterPage,
            meta: {
              title: "Sign Up"
            }
          },
          {
            path: 'sign-in',
            name: 'auth-login',
            component: LoginPage,
            meta: {
              title: "Sign In"
            }
          },
          {
            path: 'forgot-password',
            name: 'auth-reset',
            component: ResetPasswordPage,
            meta: {
              title: "Reset password"
            }
          },
          {
            path: 'reset-password',
            name: 'auth-new-password',
            component: NewPasswordPage,
            meta: {
              title: "New password"
            }
          }
        ]
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior() {
    document.querySelector('#top').scrollIntoView({ behavior: 'smooth' })
    return {
      top: 0,
      left: 0,
      behavior: 'smooth'
    }
  }
})

router.beforeEach((to, from) => {
  document.title = to.meta.title ? 'AweTemplate | ' + to.meta?.title : 'AweTemplate'
})

export default router
